import React from "react";
import { getImagePath } from "../../utilities/path";
import Picture from "../Picture";

export default function GalleryItem(props) {
    const { src, thumbnailSrc, fallbackSrc, alt, className, dataTestId, cmsId, loading = "auto" } = props;
    const fileName = src.split('/').pop();
    const ext = fileName.split('.').pop();
    const imgSrc = getImagePath(src);

    return (
        <div className="mt-4 col-4">
            <a title={alt} href={imgSrc}>
                <Picture loading={loading} data-test-id={dataTestId} src={getImagePath(thumbnailSrc)} fallbackSrc={getImagePath(fallbackSrc)} alt={alt} className="mr-4 p-2 bg-white border w-100" />
            </a>
            <a title={alt} className="btn btn-underline-dark text-left text-truncate d-block" href={imgSrc}>{alt ? alt : cmsId ? '(missing alt)' : 'Media'}</a>
            <br />
            <span className="fileFormat text-uppercase">{ext}</span>
            <a href={imgSrc} download={fileName} >
                <img src="https://www.macu.com/media/Icons/download-icon.svg" alt="download" className="downloadIcon" />
            </a>
        </div>
    );
};